
<template>
<div class="row">
    <input
        id="pac-input"
        class="controls form-control w-75"
        type="hidden"
        :placeholder="trans.get('common.search')"
    />
    <div id="map" class="min-h-50" style="width:100%"></div>
</div>
</template>

<script>
    export default {
             
        data : function(){
            return {
                longitude: 0,
                latitude: 0,
            };
        },
        mounted: function(){

            const token = process.env.MIX_GOOGLE_MAP_KEY;
            const GoogleMap = require("@googlemaps/js-api-loader");

            const loader = new GoogleMap.Loader({
                apiKey: token,
                version: "weekly",
                libraries: ["places"]
            });

            loader.load().then(() => {
                // Initiate map
                const map = new google.maps.Map(document.querySelector("#map"), {
                    center: { lat: this.latitude, lng: this.longitude },
                    zoom: 1,
                    mapTypeId: google.maps.MapTypeId.SATELLITE,
                    rotateControl: false,
                    mapTypeControl: false,
                    streetViewControl: false,
                    heading: 0,
                    tilt: 0,
                });

                google.maps.event.addListenerOnce(map, 'tilesloaded', function(){
                    input.type = "text";
                });

                const input = document.getElementById("pac-input");
                const searchBox = new google.maps.places.SearchBox(input);
                map.controls[google.maps.ControlPosition.TOP_LEFT].push(input);
                // Bias the SearchBox results towards current map's viewport.
                map.addListener("bounds_changed", () => {
                    searchBox.setBounds(map.getBounds());
                });

                const markerSite = new google.maps.Marker({
                    position: { lng: 0, lat: 0 },
                    map,
                    draggable: false,
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        text: " ",
                    },
                    icon: {
                        url: "/image/maps/marker_blue.png",
                        labelOrigin: new google.maps.Point(11, 50),
                        size: new google.maps.Size(25, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(11, 40),
                    },
                });

                const marker = new google.maps.Marker({
                    position: { lng: 0, lat: 0 },
                    map,
                    draggable: true,
                    label: {
                        color: "black",
                        fontWeight: "bold",
                        text: " ",
                    },
                    icon: {
                        url: "/image/maps/marker_red.png",
                        labelOrigin: new google.maps.Point(11, 50),
                        size: new google.maps.Size(22, 40),
                        origin: new google.maps.Point(0, 0),
                        anchor: new google.maps.Point(11, 40),
                    },
                });

                const geocoder = new google.maps.Geocoder();


                const updateAdress = (latitude, longitude) => {
                    const addressInput = document.getElementById("Adresse");
                    geocoder.geocode({location: {
                        lat: latitude,
                        lng: longitude
                    }}).then(r => {
                        if (r.results && r.results.length) {
                            addressInput.value = r.results[0].formatted_address;
                            document.getElementById("Ville").value = r.results[0].address_components[2].long_name;
                            document.getElementById("Country").value = r.results[0].address_components[5].long_name;
                        }
                    })
                };

                const updateLatLng = () =>{
                    var latitude = document.getElementById("latitude").value || 0;
                    var longitude = document.getElementById("longitude").value || 0;

                    map.setCenter({ lng: Number('' + longitude), lat: Number('' + latitude) })
                    map.setZoom(20);
                    marker.setPosition(map.getCenter());

                    updateAdress(latitude, longitude);
                };

                // Listen on longitude and latitude update
                document.getElementById("longitude").addEventListener("keyup",updateLatLng);
                document.getElementById("latitude").addEventListener("keyup", updateLatLng);

                map.addListener('click', function (e) {
                    marker.setPosition(e.latLng)    

                    var long = document.getElementById("longitude");
                    long.value = e.latLng.lng();
                    var lati = document.getElementById("latitude");
                    lati.value = e.latLng.lat();

                    updateAdress(e.latLng.lat(), e.latLng.lng());
                })

                // Listen for the event fired when the user selects a prediction and retrieve
                // more details for that place.
                searchBox.addListener("places_changed", () => {
                    const places = searchBox.getPlaces();

                    if (places.length == 0) {
                        return;
                    }

                    const bounds = new google.maps.LatLngBounds();

                    places.forEach((place) => {
                        if (!place.geometry || !place.geometry.location) {
                            return;
                        }

                        if (place.geometry.viewport) {
                            // Only geocodes have viewport.
                            bounds.union(place.geometry.viewport);
                        } else {
                            bounds.extend(place.geometry.location);
                        }

                    });

                    map.fitBounds(bounds);
                });

                google.maps.event.addListener(marker, 'dragend', (e) => {
                    var long = document.getElementById("longitude");
                    long.value = e.latLng.lng();
                    var lati = document.getElementById("latitude");
                    lati.value = e.latLng.lat();

                    updateAdress(e.latLng.lat(), e.latLng.lng());
                });

            });
        },

    }

</script>
